module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Cloud#1-e6fdbdb103da80e3dd9fa4ecbb8f0156.svg";